import BaseApiCollection from "scripts/collections/baseApiCollection";
import NoteModel from "scripts/models/noteModel";

class EpubNoteCollection extends BaseApiCollection {
  get model() {
    return NoteModel;
  }

  sortByAdded(order) {
    if (order === "asc") {
      this.comparator = noteModel => Date.parse(noteModel.get("dateAdded"));
    } else {
      this.comparator = noteModel => -Date.parse(noteModel.get("dateAdded"));
    }

    this.sort();
  }

  sortByPage(order) {
    if (order === "asc") {
      this.comparator = noteModel =>
        noteModel.has("cfiIndex") ? noteModel.get("cfiIndex") : -1;
    } else {
      this.comparator = noteModel =>
        noteModel.has("cfiIndex") ? -noteModel.get("cfiIndex") : 1;
    }

    this.sort();
  }

  pageNotes() {
    return this.filter(model => model.has("cfi"));
  }

  globalNotes() {
    return this.filter(model => !model.has("cfi"));
  }
}

export default EpubNoteCollection;
